import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/fizjoterapeuta-lodz/client/PhysioSectionClient.tsx");
